<template>
    <div class="card border-0 rounded-0 chat-wrapper chat-card h-100">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
            <div class="title pb-15">
                <h5 class="fw-medium text-black-emphasis mb-0">
                    <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium" v-if="show_patient_name">
                        <template v-if="patient != undefined">
                            {{ patient.firstname }} {{ patient.lastname }}
                        </template>
                        <template v-else>
                            ...
                        </template>
                    </span>
                    <template v-else>{{ $t('feature.messages') }} <span class="text-muted fw-normal fs-12">{{
                        total_messages
                            !==
                            0 ? `[${total_messages}]` : '' }}</span></template>
                </h5>
            </div>
            <!-- BODY -->
            <div class="chat-list flex-grow-1" id="chat-list-wrapper">
                <!-- MESSAGE -->
                <SpinnerLoading v-if="messages === undefined" class="pt-50" />
                <template v-for="(message_group, date) in message_groups" :key="date">
                    <div class="chat-item info text-center position-relative ps-0">
                        <span class="d-inline-block fs-12 text-muted bg-white ps-12 pe-12 lh-1">{{ date }}</span>
                    </div>
                    <template v-for="(messages, from_id) in message_group" :key="from_id">
                        <div class="chat-item position-relative ps-0" v-for="(message, index) in messages"
                            :key="message.id" :class="{ 'mb-0': index != messages.length - 1 }">
                            <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium mb-10">
                                <span v-if="index == 0">{{ message.from_firstname }} {{ message.from_lastname }}</span>
                            </span>
                            <!-- MESSAGE -->
                            <div class="message d-flex gap-2">
                                <div class="inner">
                                    <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium mb-1">
                                        {{ message.subject }}
                                    </span>
                                    <p class="fs-md-15 fs-lg-16 lh-base">
                                        {{ message.body }}
                                    </p>
                                </div>
                                <div class="side d-flex flex-column justify-content-between align-items-start py-1">
                                    <div class="dropdown d-inline-flex justify-content-center align-items-center">
                                        <button
                                            class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                                            type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="flaticon-dots"></i>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <button class="dropdown-item d-flex align-items-center"
                                                    v-on:click="confirmDeleteMessage(message)">
                                                    <i class="ph ph-trash lh-1 me-8 position-relative top-1"></i>
                                                    {{ $t('cta.delete') }}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="d-flex gap-1">
                                        <span class="fs-10 text-muted fw-normal lh-sm">{{
                                            date_utils.HHmm(message.posted_at) }}</span>
                                        <i class="ph ph-checks text-info" v-if="message.read_at != null"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!--  -->
                </template>
            </div>
            <form v-on:submit="submit">
                <SpinnerLoading v-if="loading === true" class="mt-25 align-items-center" />
                <div class="write-your-message position-relative d-flex pe-0 gap-3 align-items-end" v-else>
                    <div class="d-flex flex-column flex-grow-1 gap-2">
                        <div class="write-message position-relative flex-grow-1 p-0">
                            <input v-model="message_subject" type="text"
                                class="input-message d-block w-100 h-100 text-black fs-14 border-0 p-15"
                                :placeholder="$t('form.subject.placeholder')" />
                            </div>
                            <!-- ERRORS -->
                            <div class="form-messages px-1" v-if="errors?.subject ?? false">
                                <p v-for="error in errors.subject" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                                    error }}</p>
                            </div>
                        <div class="write-message position-relative flex-grow-1 p-0">
                            <textarea v-model="message_body" type="text"
                                class="input-message d-block w-100 min-h-75 text-black fs-14 border-0 p-15"
                                :placeholder="$t('form.message.placeholder')" cols="5"></textarea>
                            </div>
                            <!-- ERRORS -->
                            <div class="form-messages px-1" v-if="errors?.body ?? false">
                                <p v-for="error in errors.body" :key="error" class="small text-danger lh-1 m-0 mt-1">{{
                                    error }}</p>
                            </div>
                    </div>
                    <div class="buttons-list mt-0">
                        <!-- <button type="button" class="border-0 d-inline-block position-relative text-center transition">
                            <i class="ph ph-image"></i>
                        </button>
                        <button type="button" class="border-0 d-inline-block position-relative text-center transition">
                            <i class="ph ph-link"></i>
                        </button> -->
                        <button type="submit"
                            class="border-0 d-inline-block position-relative text-center transition active">
                            <i class="ph ph-paper-plane-tilt"></i>
                        </button>
                    </div>
                </div>

            </form>
        </div>
    </div>
    <ConfirmModal @confirm="deleteMessage()" :title="$t('cta.$delete.title')" :message="$t('cta.$delete.message')" />
</template>
<style>
#chat-list-wrapper {
    height: unset !important;
    aspect-ratio: 1.52;
}

.chat-wrapper .chat-item.info:first-child,
.chat-card .card-body .chat-list .chat-item.info:first-child {
    margin-top: 0;
}

.chat-wrapper .write-your-message .buttons-list,
.chat-card .card-body .write-your-message .buttons-list {
    top: auto !important;
    position: relative !important;
    transform: none !important;
}

.chat-wrapper.chat-item .message .dropdown,
.chat-card .card-body .chat-list .chat-item .message .dropdown {
    top: unset !important;
    right: unset !important;
    position: relative !important;
    transform: unset !important;
}

.chat-wrapper .chat-item .message .dropdown .card-dot-btn.dropdown-toggle,
.chat-card .card-body .chat-list .chat-item .message .dropdown .card-dot-btn.dropdown-toggle {
    margin-right: unset !important;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { PatientInfo } from '@/utils/models/user.model';
import { patientResolver } from "@/router/resolvers/patient.resolver";
import API from "@/services/api/api.service";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { Message } from "@/utils/models/message.model";
import DateFormatUtils from "@/utils/methods/date_formats";
import { Modal } from "bootstrap";
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";

export default defineComponent({
    name: "MessagesBody",
    props: {
        show_patient_name: {
            type: Boolean,
            default: true as boolean,
        }
    },
    data: function () {
        return {
            patient: this.$route.meta.patient,
            message_subject: undefined,
            message_body: undefined,
            loading: false,
            messages: undefined,
            selected_message: null,
            confirmModal: null,
            total_messages: 0,
            error_message: undefined,
            errors: undefined as any,
        } as {
            patient?: PatientInfo,
            message_subject?: string,
            message_body?: string,
            loading: boolean,
            messages?: Message[],
            selected_message: Message | null,
            confirmModal: Modal | null,
            total_messages: number,
            error_message?: string,
            errors?: any,
        }
    },
    beforeRouteEnter: patientResolver,
    mounted() {
        this.confirmModal = new Modal('#confirmModal', {});
        this.loadMessages();
    },
    beforeRouteUpdate: function (to, from) {
        this.patient = undefined;
        API.getPatient(to.params.id as string).then((response) => {
            if (response.data.success) {
                this.patient = response.data.data;
                this.loadMessages();
            }
        });
    },
    computed: {
        date_utils() { return DateFormatUtils },
        message_groups(): { [key: string]: { [key: string]: Message[] } } {
            let object = {};
            for (const key in this.date_groups) {
                if (Object.prototype.hasOwnProperty.call(this.date_groups, key)) {
                    const messages = this.date_groups[key];
                    object[key] = messages.reduce((acc, cur) => {
                        const from_id = cur.from_id;
                        return { ...acc, [from_id]: [...(acc[from_id] || []), cur] };
                    }, {} as { [key: string]: Message[] })
                }
            };
            return object as { [key: string]: { [key: string]: Message[] } };
        },
        date_groups(): { [key: string]: Message[] } {
            return ((this.messages ?? []) as Message[]).reverse().reduce((acc, cur) => {
                const date = DateFormatUtils.YYYYMMDD(cur.posted_at);
                return { ...acc, [date]: [...(acc[date] || []), cur] };
            }, {} as { [key: string]: Message[] });
        },
    },
    methods: {
        YYYYMMDD(date: Date): string { return DateFormatUtils.YYYYMMDD_HHmm(date) },
        loadMessages() {
            this.messages = undefined;
            this.total_messages = 0;
            if (this.patient?.id != undefined) {
                API.getMessages({ patient_id: this.patient!.id! }).then((response) => {
                    if (response.data.success === true) {
                        this.messages = response.data.data;
                        this.total_messages = response.data?.total ?? 0;
                        this.scrollBottom();
                    } else {
                        this.messages = [];
                        this.total_messages = 0
                    }
                });
            } else {
                this.messages = [];
            }
        },
        submit(event): void {
            this.error_message = undefined;
            this.errors = undefined;
            event.preventDefault();
            if (this.patient?.id != undefined && this.message_subject != undefined && this.message_body != undefined) {
                this.loading = true;
                API.sendMessage({ patient_id: this.patient!.id!, subject: this.message_subject, body: this.message_body! }).then((response) => {
                    if (response.data.success === true) {
                        this.loadMessages();
                        this.message_subject = undefined;
                        this.message_body = undefined;
                    }
                    this.error_message = response.data.message;
                    this.errors = response.data.errors;
                }).catch((error) => {
                    this.error_message = error.response.data.message;
                    this.errors = error.response.data.errors;
                    this.loading = false;
                }).finally(() => {
                    this.loading = false;
                });
            }

        },
        confirmDeleteMessage(message: Message) {
            this.selected_message = message;
            this.$data.confirmModal?.show();
        },
        deleteMessage(): void {
            API.deleteMessage({ message_id: this.selected_message!.id! }).then((response) => {
                if (response.data.success === true) {
                    this.selected_message = null;
                    this.loadMessages();
                }
            }).finally(() => {
                console.log("DELETED_MESSAGE_ID", this.selected_message?.id);
            })
        },
        scrollBottom() {
            let container = document.getElementById('chat-list-wrapper');
            setTimeout(() => {
                if (container != null) {
                    container!.scrollTop = container?.scrollHeight;
                }
            }, 10);
        }
    },
    components: {
        SpinnerLoading,
        ConfirmModal,
    }
});
</script>